export function aa(){
    console.log(111111);
}




export function loadStyle(){
// 动态添加style标签，来实现自定义faq样式的功能
    return new Promise(resolve => {
        
        let styleNode = document.createElement("style");
        styleNode.setAttribute("type","text/css");
        styleNode.innerHTML = `
            .cus{
                color:red;
            }
            html{
                box-sizing:border-box;
            }
            body{
                margin:100px;
                border:1px solid red;
            }
        `;
        let headNode = document.querySelector('head');
        headNode.appendChild(styleNode);
        aa()
        resolve();
    })
}